import { render, staticRenderFns } from "./BFormInputTime.vue?vue&type=template&id=aea68e06"
import script from "./BFormInputTime.vue?vue&type=script&lang=js"
export * from "./BFormInputTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports